"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CanalesDeAtenciN() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const departments = [{
    number: "01",
    label: "COTIZACIONES",
    description: "Consultoría especializada para nuevos proyectos de seguridad privada y protección corporativa.",
    email: "ventas@poseidon.com.mx",
    phone: "(55) 1234-5678",
    contactName: "Ing. Roberto Casillas",
    contactRole: "Director Comercial"
  }, {
    number: "02",
    label: "CENTRO DE MONITOREO",
    description: "Atención 24/7 para clientes activos, gestión de alarmas y respuesta inmediata a incidentes.",
    email: "monitoreo@poseidon.com.mx",
    phone: "(55) 1234-5679",
    contactName: "Cap. Arturo Méndez",
    contactRole: "Jefe de Operaciones"
  }, {
    number: "03",
    label: "RECURSOS HUMANOS",
    description: "Información sobre procesos de reclutamiento, capacitación táctica y certificaciones vigentes.",
    email: "talento@poseidon.com.mx",
    phone: "(55) 1234-5680",
    contactName: "Lic. Elena Vargas",
    contactRole: "Directora de RH"
  }, {
    number: "04",
    label: "SOPORTE TÉCNICO",
    description: "Asistencia para sistemas de videovigilancia, rastreo GPS y mantenimiento de infraestructura.",
    email: "soporte@poseidon.com.mx",
    phone: "(55) 1234-5681",
    contactName: "Ing. David Soto",
    contactRole: "Líder de Tecnología"
  }];
  return <section data-section-id="4795" id="canales-de-atención" className="bg-background text-foreground py-24 md:py-32 lg:py-44 px-6 md:px-10 lg:px-16">
      <div ref={ref} className={`max-w-[1400px] mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 mb-20 md:mb-28 lg:mb-32">
          <div className="lg:col-span-7">
            <div className="font-mono text-xs tracking-[0.15em] text-primary mb-8 md:mb-10 uppercase" style={{
            fontFamily: "var(--font-mono)"
          }}>
              — CANALES DE ATENCIÓN
            </div>
            <h2 className="font-default font-bold text-5xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tighter text-foreground">
              Contacto{" "}
              <span className="italic font-normal" style={{
              fontFamily: "var(--font-serif)"
            }}>
                estratégico.
              </span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex lg:items-end">
            <p className="text-lg md:text-xl leading-relaxed text-muted-foreground" style={{
            fontFamily: "var(--font-sans)"
          }}>
              Líneas directas con nuestros mandos operativos. Cada departamento está liderado por un especialista en seguridad integral.
            </p>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-border">
          {departments.map((dept, i) => <div data-index={i} key={dept.number} className={`group relative flex flex-col px-0 md:px-8 lg:px-10 py-12 md:py-14 transition-colors duration-500 hover:bg-accent/10 ${i < departments.length - 1 ? "border-b border-border md:border-b lg:border-b-0" : ""} ${i % 2 === 0 ? "md:border-r md:border-border" : ""} ${i < 2 ? "md:border-b md:border-border lg:border-b-0" : ""} lg:border-r lg:border-border lg:last:border-r-0`}>
              {}
              <div className="font-mono text-[11px] tracking-[0.15em] text-primary mb-10 md:mb-14 uppercase" style={{
            fontFamily: "var(--font-mono)"
          }}>
                {dept.number} / {dept.label}
              </div>

              {}
              <p className="text-2xl leading-[1.3] text-foreground mb-14 md:mb-20 flex-1 font-default font-semibold" style={{
            fontFamily: "var(--font-sans)"
          }}>
                {dept.description}
              </p>

              {}
              <div className="space-y-6">
                <div>
                  <div className="font-mono text-[10px] tracking-[0.15em] text-muted-foreground mb-2 uppercase" style={{
                fontFamily: "var(--font-mono)"
              }}>
                    CORREO ELECTRÓNICO
                  </div>
                  <Link to={`mailto:${dept.email}`} className="text-base text-foreground hover:text-primary hover:underline decoration-primary underline-offset-4 transition-colors duration-300 break-all font-default" style={{
                fontFamily: "var(--font-sans)"
              }}>
                    {dept.email}
                  </Link>
                </div>

                <div>
                  <div className="font-mono text-[10px] tracking-[0.15em] text-muted-foreground mb-2 uppercase" style={{
                fontFamily: "var(--font-mono)"
              }}>
                    TELÉFONO
                  </div>
                  <Link to={`tel:${dept.phone.replace(/[^\d+]/g, "")}`} className="text-base text-foreground hover:text-primary transition-colors duration-300 font-default" style={{
                fontFamily: "var(--font-sans)"
              }}>
                    {dept.phone}
                  </Link>
                </div>

                <div>
                  <div className="font-mono text-[10px] tracking-[0.15em] text-muted-foreground mb-2 uppercase" style={{
                fontFamily: "var(--font-mono)"
              }}>
                    RESPONSABLE
                  </div>
                  <div className="text-base text-foreground font-default" style={{
                fontFamily: "var(--font-sans)"
              }}>
                    <span className="font-semibold">{dept.contactName}</span>
                    <span className="text-foreground/50"> / </span>
                    <span className="italic text-muted-foreground">{dept.contactRole}</span>
                  </div>
                </div>

                {}
                <div className="pt-8">
                  <Link to={`mailto:${dept.email}`} className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.15em] text-primary hover:gap-4 transition-all duration-300 uppercase" style={{
                fontFamily: "var(--font-mono)"
              }}>
                    <ArrowRight className="size-3" />
                    ENVIAR MENSAJE
                  </Link>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}